import DiscourseRoute from "discourse/routes/discourse";

// The controller serves /best-for/:use_case as fully server-rendered HTML
// (crawler layout, no Ember bootstrap) because the Ember client renderer
// crashes Glimmer on this Discourse build — route-template each-blocks abort
// at ~5 dynamic content nodes, which left pages with a single provider card.
//
// This route exists ONLY so that in-app navigations (clicking a use-case card
// on the /best-for index) bounce to a full page load, letting the server
// render the premium page. Direct loads never reach this code — the crawler
// layout ships no Ember JS.
export default class ProxyviewsBestForRoute extends DiscourseRoute {
  redirect(_model, transition) {
    // During redirect() the history URL is still the previous page — the
    // intended target lives on the transition.
    const target = transition && transition.intent && transition.intent.url;
    window.location.assign(target || window.location.href);
  }
}
